






































// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import BasePagination from '@/base/BasePagination.vue';
import TheTableOrders from '@/components/orders/TheTableOrders.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
// Importing function
import {getOrders} from '@/ts/orders/get-orders';
// Importing Pusher
import Pusher from 'pusher-js';

export default {
    name: 'PageTrackOrders',
    components: {
        LayoutApp,
        BaseCard,
        BasePagination,
        TheTableOrders,
        BaseButton,
        BaseInputField,
    },
    props: {},
    data() {
        return {
            items: [],
            search_param: '',
            order: {},
            status: {},
            channel: {},
            lat: 0,
            lan: 0,
        };
    },
    methods: {
        error() {
            this.$swal.fire({
                title: 'Възникна грешка!',
                type: 'error',
                text: 'В момента поръчката не се доставя!',
            }).then(() => {
                this.$router.go(-1);
            });
        },
    },
    beforeDestroy() {
        this.channel.unbind();
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Поръчки',
            to: { path: '/orders' },
        }, {
            text: 'Проследяване на доставка',
        }];
        this.$store.dispatch('setQueryParam', '');
        this.$store.dispatch('setOrderParam', '');
        this.$store.dispatch('setSortParam', '');

    },
    mounted() {
        getOrders().then(() => {
            this.$store.dispatch('setResponse',
                this.$store.getters.response.filter((item) => item.id === this.$route.params.order_id));
            if (this.$store.getters.response[0].attributes.status !== 'DELIVERING') { this.error(); }
            const pusher = new Pusher('1627464172e6c947c3f4', {
                cluster: 'eu',
                encrypted: true,
                authEndpoint: 'https://api.foodninja.net/broadcasting/auth',
                auth: {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('jwt'),
                    },
                },
            });

            // Subscribe to the channel we specified in a Laravel Event
            const datum = this.$store.getters.response[0].attributes;
            this.channel = pusher.subscribe('private-deliveries.' + datum.delivery_user_id);
            this.channel.bind('client-location', (position) => {
                this.lat = position.lat;
                this.lan = position.lng;
            });
        });
    },
};
